import type { FormValues, OnlyPasswordFormValues } from '../types/form'

export enum FormFieldNames {
	Email = 'email',
	Password = 'password',
	Phone = 'phone',
	BirthDate = 'birthDate',
	LegalConfirmation = 'legalConfirmation',
	NewsletterSubscription = 'newsletterSubscription',
}

export enum FormFieldIds {
	Email = 'registry-form-email-input',
	Password = 'registry-form-password-input',
	Phone = 'registry-form-phone-input',
	BirthDate = 'registry-form-birth-date-input',
	LegalConfirmation = 'registry-form-legal-confirmation-checkbox',
	NewsletterSubscription = 'registry-form-newsletter-subscription-checkbox',
	RegistryButton = 'registry-form-submit',
}

export const staticDefaultValues: FormValues = {
	email: '',
	password: '',
	phone: {
		phoneCountryIso: '',
		phonePrefix: '',
		phoneNumber: '',
	},
	birthDate: '',
	legalConfirmation: false,
	newsletterSubscription: true,
}

export const staticDefaultOnlyPaswordValues: OnlyPasswordFormValues = {
	password: '',
}

export enum TestIds {
	EmailInput = 'registry.emailInput.text',
	EmailInputErrorMessage = 'registry.emailInput.errorMessage',
	PasswordInput = 'registry.passwordInput.text',
	PasswordInputErrorMessage = 'registry.passwordInput.errorMessage',
	PhoneNumber = 'registry.phoneInput.phoneNumber',
	PhoneCountryPrefix = 'registry.phoneInput.prefix',
	PhoneSelectPrefix = 'registry.phoneInput.select.toggle',
	BirthDate = 'registry.birthDateInput.text',
	BirthDateErrorMessage = 'registry.birthDateInput.errorMessage',
	PrivacyPolicyDefault = 'registry.privacyPolicy.text',
	PrivacyPolicyInsideForm = 'registry.privacyPolicy.form.text',
	LegalConfirmation = 'registry.legalConfirmation.checkbox',
	LegalConfirmationPdf = 'registry.legalConfirmationPdf.checkbox',
	NewsletterSubscription = 'registry.newsletterSubscription.subscribe',
	RegistryButton = 'registry.registryButton.registry',
	RetryButton = 'registry.genericError.retrySubmit',
	CancelButton = 'registry.genericError.emptyFields',
}

export enum RegistrySumbitErrors {
	Generic = 'generic',
	Email = 'email',
	Password = 'password',
	Mobile = 'mobile',
}

export enum FormErrorTypes {
	Required = 'required',
	Root = 'root',
	MaxLength = 'maxLength',
	Pattern = 'pattern',
	Validate = 'validate',
}
